"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FormControl_1 = require("@material-ui/core/FormControl");

var IconButton_1 = require("@material-ui/core/IconButton");

var Input_1 = require("@material-ui/core/Input");

var InputAdornment_1 = require("@material-ui/core/InputAdornment");

var Close_1 = require("@material-ui/icons/Close");

var Search_1 = require("@material-ui/icons/Search");

var React = require("react");

var styles = {
  formControl: {
    margin: '10px',
    width: 250
  }
};

exports.SearchTextInput = function (_a) {
  var searchText = _a.searchText,
      updateSearchText = _a.updateSearchText;

  var onChange = function onChange(e) {
    return updateSearchText(e.target.value);
  };

  var onClear = function onClear() {
    return updateSearchText('');
  };

  var adorment = React.createElement(InputAdornment_1["default"], {
    position: 'end'
  }, React.createElement(Search_1["default"], null));
  return React.createElement(FormControl_1["default"], {
    style: styles.formControl
  }, React.createElement(Input_1["default"], {
    fullWidth: true,
    type: 'text',
    value: searchText,
    onChange: onChange,
    startAdornment: adorment,
    endAdornment: searchText !== '' && React.createElement(InputAdornment_1["default"], {
      position: 'end'
    }, React.createElement(IconButton_1["default"], {
      onClick: onClear
    }, React.createElement(Close_1["default"], null)))
  }));
};